import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Certificate } from '@/entities/Certificates';
import { IndeterminateCheckbox } from '@/shared/ui/IndeterminateCheckbox';
import { AppImage } from '@/shared/ui/AppImage';

export const certificatesCourseColumns: ColumnDef<Certificate>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <IndeterminateCheckbox
        uniqueKey="all-certificates-select"
        name="all-certificates"
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <IndeterminateCheckbox
        uniqueKey={`certificate-select-${row.original.id}`}
        name="certificate"
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
  },
  {
    header: 'Name',
    accessorKey: 'pdfFile.name',
    cell: ({ row }) => (
      <span className="text-black-headline truncate max-w-[180px] block">
        {row.original.pdfFile?.name ?? row.original.imageFile?.name ?? '—'}
      </span>
    ),
  },
  {
    header: 'Student Name',
    accessorKey: 'studentName',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.studentName}</span>
    ),
  },
  {
    header: 'Student ID',
    accessorKey: 'studentId',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.studentId}</span>
    ),
  },
  {
    header: 'Grade / Score',
    accessorKey: 'grade',
    cell: ({ row }) => (
      <span className="text-black-headline">
        {row.original.grade != null ? `${row.original.grade}%` : '—'}
      </span>
    ),
  },
  {
    header: 'Certificate ID',
    accessorKey: 'certificateNumber',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.certificateNumber}</span>
    ),
  },
  {
    header: 'Added By',
    accessorKey: 'issuedBy',
    cell: ({ row }) => {
      const issuedBy = row.original.issuedBy;
      if (!issuedBy) return <span className="text-grey-secondary">—</span>;
      return (
        <div className="flex items-center gap-2">
          {issuedBy.avatar ? (
            <AppImage
              src={issuedBy.avatar}
              alt={issuedBy.username}
              className="w-8 h-8 rounded-full object-cover"
            />
          ) : (
            <div className="w-8 h-8 rounded-full bg-grey-100 flex items-center justify-center text-sm font-semibold text-grey-secondary">
              {issuedBy.username?.charAt(0) ?? '?'}
            </div>
          )}
          <span className="text-black-headline">{issuedBy.username}</span>
        </div>
      );
    },
  },
  {
    header: 'Date',
    accessorKey: 'issuedAt',
    cell: ({ row }) => {
      const dateStr = row.original.issuedAt;
      if (!dateStr) return <span className="text-grey-secondary">—</span>;
      try {
        return (
          <span className="text-black-headline">
            {format(new Date(dateStr), 'dd.MM.yyyy')}
          </span>
        );
      } catch {
        return <span className="text-black-headline">{dateStr}</span>;
      }
    },
  },
];
